<script>
    import { Router, Link, Route, link, navigate } from "svelte-routing";
    import { onMount } from 'svelte';
    import { _completeExamData, _userObj } from "./store.js";
    import MultipleChoiceQuestion from "./multipleChoiceQuestion.svelte";
    import MultipleResponseQuestion from "./multipleChoiceResponse.svelte";
    import NumericalQuestion from "./numerical.svelte";
    import QuestionReport from "./questionReportCom.svelte";

    export let currentQuestionNo;
    export let currentSectionNo;
    export let token;

    let statId;

    let userObj = {
        name: "",
        mobileNo: ""
    };

    let show = false;

    let isShowModal =false;

    let language = "English";

    let currentQuestion = {};

    let userResponses = {}

    let questionBank = {};

    let completeExamData = {};

    let maxMarks = 0;
    
    let visible = true;

    let remainingTime = 0;

    let disableBtn=false;

    let isSubmitting=false;


    $: currentQuestion = questionBank[completeExamData.sections && completeExamData.sections[currentSectionNo - 1].questions[currentQuestionNo - 1]];

    $: language = currentQuestion?.data?.question[language] ? language : "English";

    const isAllowedToAnswer = function(inputQuestionId){

        let thisSectionIndex, thisSectionQuestionSet;
        for (let h = 0; h < completeExamData.sections.length; h++) {
            const aSection = completeExamData.sections[h];
            for (let k = 0; k < aSection.questions.length; k++) {
                if(aSection.questions[k] == inputQuestionId){
                    thisSectionIndex = h;
                    thisSectionQuestionSet = aSection.questions;
                    break;
                }
            }
        }

        let isLimitQuestions = completeExamData.sections[thisSectionIndex].isLimitQuestions;
        let sectionLimit = completeExamData.sections[thisSectionIndex].qLimit;
        if(isLimitQuestions){
            let sectionAnswered = 0;
            for (let l = 0; l < thisSectionQuestionSet.length; l++) {
                const aQ = thisSectionQuestionSet[l];
                if(userResponses[aQ] && userResponses[aQ].answer){
                    sectionAnswered++
                }
            }
            if(sectionAnswered > sectionLimit){
                return {status : false, sectionLimit}
            }else{
                return {status : true, sectionLimit}
            }
        }else{
            return {status : true, sectionLimit}
        }
        
    }

    const ansChanged = function(data){
        console.log("Ans changed")
        if(!userResponses[data.qId]) userResponses[data.qId] = {}
        userResponses[data.qId].answer = data.ans;
        let isAllowedObj = isAllowedToAnswer(data.qId);
        if(isAllowedObj.status){
            saveCurrentQuestionState();
        }else{
            delete userResponses[data.qId].answer;
            alert("You can only attempt "+ isAllowedObj.sectionLimit+" question in this section");
        }
        
    }

    const toggleMarked = function(data){
        console.log("toggleMarked Changed : ", data)
        if(!userResponses[data.qId]) userResponses[data.qId] = {}
        userResponses[data.qId].marked = !userResponses[data.qId].marked;
        saveCurrentQuestionState();
    }

    const questionVisited = function(data){
        if (!userResponses[data.qId]) userResponses[data.qId] = {}
        userResponses[data.qId].visited = true;
    }

    const expand = (sectionTitle) => {
        if (completeExamData.sections) {
            for (let i = 0; i < completeExamData.sections.length; i++) {
                if (completeExamData.sections[i].title == sectionTitle) {
                    completeExamData.sections[i].active = !completeExamData.sections[i].active;
                }
            }
        }
    }

    const submitTest = async function(forceSubmit){
        disableBtn = true;
        console.log("forceSubmit : ", forceSubmit)

        if(forceSubmit){
            console.log("userResponses : ", userResponses)
            await saveCurrentQuestionState();
            let submitRes = await api_submitTest({
                statId: statId
            })
            console.log("api_submitTest : ", submitRes)
            window.isExamEnded = true;
            if(window.submitInterval) clearInterval(window.submitInterval)
            navigate("/result/" + submitRes.doneTestId, { replace: true })
        }else{
            var play = confirm("Are you sure you want Submit?");
            if (play == true) {
                var randomNo = Math.ceil(Math.random() * 10000);
                var input = prompt("Please enter the code displayed bellow to submit the exam\n\n" + randomNo);
                if (input != randomNo) {
                    alert("Invalid OTP");
                    disableBtn = false;
                    return;
                }
                console.log("userResponses : ", userResponses)
                await saveCurrentQuestionState();
                let submitRes = await api_submitTest({
                    statId: statId
                })
                console.log("api_submitTest : ", submitRes)
                window.isExamEnded = true;
                if(window.submitInterval) clearInterval(window.submitInterval)
                navigate("/result/" + submitRes.doneTestId, { replace: true })
            } else {
                disableBtn = false
            }
        }
    }

    const onBackBtnClick = () => {
        if (currentSectionNo == 1 && currentQuestionNo == 1) {

        } else {
            if (currentSectionNo != 1 && currentQuestionNo == 1) {
                toQuestion(completeExamData.sections[Number(currentSectionNo) - 1].questions.length, (Number(currentSectionNo) - 1) )
            } else {
                toQuestion((Number(currentQuestionNo) - 1) , (currentSectionNo))
            }
        }
    }

    const onNextBtnClick = () => {

        if (completeExamData.sections && currentSectionNo == completeExamData.sections.length && currentQuestionNo == completeExamData.sections[currentSectionNo
            - 1].questions.length) {
            submitTest();
            return;
        }

        if (currentSectionNo == completeExamData.sections.length && currentQuestionNo == completeExamData.sections[currentSectionNo - 1].questions.length) {
        } else {
            if (currentQuestionNo >= completeExamData.sections[currentSectionNo - 1].questions.length) {
                toQuestion(1, (Number(currentSectionNo) + 1))
            } else {
                toQuestion((Number(currentQuestionNo) + 1), (currentSectionNo))
            }
        }
    }

    const saveCurrentQuestionState = async function(){
        let questionId = currentQuestion._id;
        let qState = userResponses[questionId];
        await api_saveCurrentQuestionState({
            questionId : questionId,
            visited : qState.visited,
            answer : qState.answer,
            timer : qState.timer,
            marked : qState.marked,
            currentQuestionNo : Number(currentQuestionNo),
            currentSectionNo : Number(currentSectionNo),
            statId : statId,
            testId : completeExamData._id,
            userId : userObj._id
        })
    }

    const toQuestion = (qIndex, sIndex, fromSideBar) =>{
        
        

        saveCurrentQuestionState();

        api_updateCurrentQuestionNo({
                statId: statId,
                currentQuestionNo: Number(qIndex),
                currentSectionNo: Number(sIndex),
        })

        navigate("/questions/"+token + "/" + (qIndex) + "/" + (sIndex)); 
    
        if(fromSideBar){
            show = !show
        }

    }

    async function api_getInfo() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var payload = JSON.stringify({
            token: token,
        });
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: payload,
        };
        try {
            var resObj = await fetch(  '/testAPI/getInfo', requestOptions);
            var response = await resObj.json();
            return response;
        } catch (error) {
            console.error("error", error);
            return { error: error };
        }
    }
    // async function api_getMyTests(testObj) {
    //     var requestOptions = {
    //         method: "GET",
    //     };
    //     try {
    //         var resObj = await fetch(  "/testAPI/testData/" + testObj.orgId + "/" + testObj.testId + ".json", requestOptions);
    //         console.log("resObj : ", resObj)
    //         var response = await resObj.json();
    //         return response;
    //     } catch (error) {
    //         console.error("error", error);
    //         return { error: error };
    //     }
    // }
    async function api_testStarted(data) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var payload = JSON.stringify(data);
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: payload,
            };
            try {
                var resObj = await fetch(  '/testAPI/testStarted', requestOptions);
                var response = await resObj.json();
                return response;
            } catch (error) {
                console.error("error", error);
                return { error: error };
            }
        }
    async function api_saveCurrentQuestionState(data) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var payload = JSON.stringify(data);
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: payload,
            };
            try {
                var resObj = await fetch(  '/testAPI/saveCurrentQuestionState', requestOptions);
                var response = await resObj.json();
                return response;
            } catch (error) {
                console.error("error", error);
                return { error: error };
            }
        }
    async function api_updateCurrentQuestionNo(data) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var payload = JSON.stringify(data);
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: payload,
            };
            try {
                var resObj = await fetch(  '/testAPI/updateCurrentQuestionNo', requestOptions);
                var response = await resObj.json();
                return response;
            } catch (error) {
                console.error("error", error);
                return { error: error };
            }
        }
    async function api_submitTest(data) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var payload = JSON.stringify(data);
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: payload,
        };
        try {
            var resObj = await fetch(  '/testAPI/submitTest', requestOptions);
            var response = await resObj.json();
            return response;
        } catch (error) {
            console.error("error", error);
            return { error: error };
        }
    }


    _userObj.subscribe(value => { userObj = value });

    _completeExamData.subscribe(value => {
        maxMarks = 0;
        if (value && value.qTextObj) {
            for (let i = 0; i < value.qTextObj.length; i++) {
                maxMarks += value.qTextObj[i].additionalInfo.pmarks;
            }
        }
        if (value && value.sections) {
            for (let i = 0; i < value.sections.length; i++) {
                value.sections[i].active = true;
            }
        }
        if (value && value.qTextObj) {
            for (let i = 0; i < value.qTextObj.length; i++) {
                questionBank[value.qTextObj[i]._id] = value.qTextObj[i];
            }
        }
        completeExamData = value
    });

    onMount(async () => {

        if(isExamEnded){
            alert("Exam already Ended");
            window.close();
            return;
        }
        if (!userObj.name) {
            let tokenRes = await api_getInfo();
            userObj = tokenRes.userObj;
            _userObj.set(userObj);

            if (tokenRes.doneTest) {
                alert("Test already submitted")
                navigate("/result/" + tokenRes.doneTest._id, { replace: true })
            }

            // let response = await api_getMyTests({
            //     orgId: userObj.orgId,
            //     testId: tokenRes.testId
            // });
            // _completeExamData.set(response);
            // console.log("response : ", response)
            // console.log(" completeExamData : ", completeExamData)

            _completeExamData.set(JSON.parse(tokenRes.completeTestData.testData));

        } else {
            console.log("Loaded")
        }

        let startRes = await api_testStarted({
            userId : userObj._id,
            testId : completeExamData._id
        });

        if(startRes.doneTest){
            alert("Test already submitted")
            navigate("/result/" + startRes.doneTest._id, { replace: true })
        }

        if(startRes.testStats){
            for (let i = 0; i < startRes.testStats.length; i++) {
                startRes.testStats[i];
                userResponses[startRes.testStats[i].questionId] = {
                    answer : startRes.testStats[i].answer,
                    marked : startRes.testStats[i].marked,
                    timer : Number(startRes.testStats[i].timer),
                    visited : startRes.testStats[i].visited,
                }
            }
        }

        let serverTime = new Date(startRes.serverTime);
        let testExpiresAt = new Date(startRes.onGoingTest.expiresAt);
        remainingTime = (testExpiresAt - serverTime) / 1000;

        console.log("remainingTime : ", remainingTime)
        statId = startRes.onGoingTest._id;
        navigate("/questions/" + token + "/" + startRes.onGoingTest.currentQuestionNo + "/" + startRes.onGoingTest.currentSectionNo)
        let examEndedShown = false;
        window.submitInterval = setInterval(function () { 
            if (currentQuestion._id) {
                if(!userResponses[currentQuestion._id]) userResponses[currentQuestion._id] = { timer : 0};

                userResponses[currentQuestion._id].timer = userResponses[currentQuestion._id].timer ? (userResponses[currentQuestion._id].timer + 1) : 1
            }
            remainingTime--;
            if(remainingTime < 1){
                remainingTime = 0
                if(!examEndedShown){
                    examEndedShown= true;
                    if(!(window.isExamEnded || disableBtn)){
                        submitTest(true);
                        alert("Exam Ended");
                    }
                }
            }
        }, 1000);
    });
</script>
<div class="container">
    <main>
        <div class="q-header" >
            <div class="win-action" on:click={()=>window.history.back()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-arrow-left">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
            </div>
            <div class="exam-info">
                {completeExamData.name}
            </div>
            
            <div class="timer">
                <div class="timer-value">
                    <div class="h-timer">
                        <div class="h-timer-count">
                            {Math.floor(remainingTime / 3600)}
                        </div>
                        <div class="timer-txt">
                            hh
                        </div>
                    </div>
                    <div class="timer-seperator">
                        :
                    </div>
                    <div class="m-timer">
                        <div class="m-timer-count">
                            {Math.floor(remainingTime % 3600 / 60)}
                        </div>
                        <div class="timer-txt">
                            mm
                        </div>
                    </div>
                    <div class="timer-seperator">
                        :
                    </div>
                    <div class="s-timer">
                        <div class="s-timer-count">
                            {Math.floor(remainingTime % 3600 % 60)}
                        </div>
                        <div class="timer-txt">
                            ss
                        </div>
                    </div>
                </div>
                <div class="time-left-txt">
                    Time Left
                </div>
            </div>
            <div class="open-aside" on:click={()=>show=!show}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu">
                    <line x1="3" y1="12" x2="21" y2="12"></line>
                    <line x1="3" y1="6" x2="21" y2="6"></line>
                    <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
            </div>
        </div>
        {#if completeExamData.sections && completeExamData.sections.length != 1 && completeExamData.sections[0].title != "All Questions"}
            <div class="q-sections">
                {#each completeExamData.sections as aSection, index}
                <div 
                    class="a-sec" class:active={index == (currentSectionNo-1)}
                    on:click={()=>{toQuestion(1,(index+1))}}
                    >
                    {aSection.title}({aSection.questions.length})

                </div>
                {/each}
            </div>
		{/if}
		<div class="q-info">
			<div class="q-number">
				Question No : {currentQuestionNo}
			</div>
			<div class="q-time">
				00:{(userResponses[currentQuestion?._id] && userResponses[currentQuestion?._id].timer) ? userResponses[currentQuestion?._id].timer : 0}
			</div>
			<div class="q-marks">
				Marks : +{
				    currentQuestion && currentQuestion.additionalInfo && currentQuestion.additionalInfo.pmarks ? currentQuestion.additionalInfo.pmarks : 0
				} / -{
                    currentQuestion && currentQuestion.additionalInfo && currentQuestion.additionalInfo.nmarks ? currentQuestion.additionalInfo.nmarks : 0
				}
			</div>
            <div class="exam-info">
              <button class="bottom-btn report-color" on:click={()=>{isShowModal = !isShowModal}}>
                Report
              </button>
            </div>
			<div class="q-lang">
				<select name="" id="" bind:value={language}>
                    {#if currentQuestion && currentQuestion.data}
                        {#each Object.entries(currentQuestion?.data?.question) as [langName, langValue]}
                            <option value="{langName}">{langName}</option>
                        {/each}
                    {/if}
				</select>
			</div>
		</div>
		<div class="q-content">
			{#if currentQuestion?.data?.isEssayAttached && currentQuestion?.data?.isEssayAttached[0] == "true"}
			<div class="q-essay">
				<div class="q-label">
					Essay :
				</div>
				<div class="q-essay-data">
					{@html (currentQuestion?.data?.attachEssay[language]?.content || "")}
				</div>
			</div>
			{/if}
			<div class="q-data">
				<div class="q-question">
					<div class="q-label">
						Question :
					</div>
					<div class="q-content-body">
						{@html currentQuestion?.data?.question[language]}
					</div>
                </div>
                {#if currentQuestion}
                    {#key currentQuestion?._id}

                        {#if currentQuestion?.qType == "multipleChoice" }
                            <MultipleChoiceQuestion 
                                mode="test" 
                                currentQuestion={currentQuestion} 
                                ansChanged={ansChanged} 
                                language={language}
                                questionVisited={questionVisited} 
                                thisQUserResponses={userResponses[currentQuestion?._id] ? userResponses[currentQuestion?._id] : {}} 
                            />

                        {:else if currentQuestion?.qType == "multipleResponse"}
                            <MultipleResponseQuestion 
                                mode="test" 
                                currentQuestion={currentQuestion} 
                                ansChanged={ansChanged} 
                                language={language}
                                questionVisited={questionVisited} 
                                thisQUserResponses={userResponses[currentQuestion?._id] ? userResponses[currentQuestion?._id] : {}} 
                            />
                        {:else if currentQuestion?.qType == "numerical"}
                            <NumericalQuestion 
                                mode="test" 
                                currentQuestion={currentQuestion} 
                                ansChanged={ansChanged} 
                                language={language}
                                questionVisited={questionVisited} 
                                thisQUserResponses={userResponses[currentQuestion?._id] ? userResponses[currentQuestion?._id] : {answer:''}} 
                            />
                        {:else}
                            -
                        {/if}
                    {/key}
                {/if}
			</div>
		</div>
		<div class="q-footer">
			<button class="bottom-btn" on:click={onBackBtnClick}>
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
					stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
					class="feather feather-chevron-left">
					<polyline points="15 18 9 12 15 6"></polyline>
				</svg>
			</button>
			<button class="bottom-btn" on:click={()=>toggleMarked({qId : currentQuestion?._id})}>
                Mark For Review
			</button>
			<button class="bottom-btn" on:click={()=>ansChanged({qId : currentQuestion?._id, ans : undefined})}>
                Clear Response
			</button>
			<div class="f1"></div>
			<button class="bottom-btn" on:click={onNextBtnClick}>
				{#if completeExamData.sections && currentSectionNo == completeExamData.sections.length && currentQuestionNo == completeExamData.sections[currentSectionNo
				- 1].questions.length}
                    Submit Test
				{:else}
                    Save & Next
				{/if}
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
					stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
					class="feather feather-chevron-right">
					<polyline points="9 18 15 12 9 6"></polyline>
				</svg>
			</button>
		</div>
	</main>
	<nav class="menu" tabindex="0" class:show={show}>
		<!-- <div class="smartphone-menu-trigger"></div> -->
		<!-- <div class="smartphone-menu-trigger-close"></div> -->
		<div class="avater">
			<div class="avatar-img">
				<img src="/images/user.jpg" style="border-radius: 50%; height: 42px;" alt="">
			</div>
			<div class="user-info">
				<div class="user-name">
					{userObj.name}
				</div>
				<div class="user-email-phno">
					{userObj.mobileNo}
				</div>
			</div>
			<div class="close-aside" on:click={()=>show=!show}>
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
					stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
					class="feather feather-x">
					<line x1="18" y1="6" x2="6" y2="18"></line>
					<line x1="6" y1="6" x2="18" y2="18"></line>
				</svg>
			</div>
		</div>
		<div class="side-section-options">
			<div class="grid-view active">
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
					stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
					class="feather feather-grid">
					<rect x="3" y="3" width="7" height="7"></rect>
					<rect x="14" y="3" width="7" height="7"></rect>
					<rect x="14" y="14" width="7" height="7"></rect>
					<rect x="3" y="14" width="7" height="7"></rect>
				</svg>
			</div>
			<div class="list-view ">
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
					stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
					class="feather feather-list">
					<line x1="8" y1="6" x2="21" y2="6"></line>
					<line x1="8" y1="12" x2="21" y2="12"></line>
					<line x1="8" y1="18" x2="21" y2="18"></line>
					<line x1="3" y1="6" x2="3.01" y2="6"></line>
					<line x1="3" y1="12" x2="3.01" y2="12"></line>
					<line x1="3" y1="18" x2="3.01" y2="18"></line>
				</svg>
			</div>
		</div>
		<div class="side-sections">
			{#if completeExamData.sections}
                {#each completeExamData.sections as section, sIndex}
                    <div class="accordion">
                        <div class="sec-header" on:click={() => expand(section.title) }>
                            {section.title}
                        </div>
                        {#if section.active}
                        <div class="slider fadeIn" style="justify-content: center;">
                            {#each section.questions as item, qIndex (item)}
                            <div 
                                class="q-btn"
                                class:current={currentQuestionNo == qIndex+1 && currentSectionNo == sIndex+1}
                                class:marked={userResponses[item]?.marked}
                                class:answered={
                                    userResponses[item]?.answer?.length
                                }
                                class:not-answered={ !userResponses[item]?.marked && !userResponses[item]?.answer?.length &&  userResponses[item]?.visited}
                                on:click={()=>toQuestion((qIndex+1),(sIndex+1), true )}
                            >
                                <div class="q-list-no">{qIndex+1}</div>
                            </div>
                            {/each}
                        </div>
                        {/if}
                    </div>
                {/each}
			{/if}
		</div>
		<div class="legends">
			<table >
				<tr>
					<td>
						<div>
							<div class="q-btn answered leg">
								<div class="q-list-no"> </div>
							</div>
							Correct
						</div>
					</td>
					<td>
						<div>
							<div class="q-btn marked leg">
								<div class="q-list-no"> </div>
							</div>
							Marked
						</div>
					</td>
				</tr>
				<tr>
					<td>
						<div>
							<div class="q-btn not-answered leg">
								<div class="q-list-no"> </div>
							</div>
							Not answered
						</div>
					</td>
					<td>
						<div>
							<div class="q-btn current leg">
								<div class="q-list-no"> </div>
							</div>
							Current
						</div>
					</td>
				</tr>
			</table>
		</div>
		<button class="submit" disabled={disableBtn}  on:click={()=>submitTest()}>
			Submit
		</button>
	</nav>
</div>
{#if isShowModal}
   <QuestionReport questionId={currentQuestion?._id} testId={completeExamData._id} userObj={userObj} onHide={()=>isShowModal =false}/>
{/if}